//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

export class ApiBaseClass {
  protected getBaseUrl = (defaultUrl: string, baseUrl: string | undefined) => {
    return process.env.REACT_APP_API_BASE_URL || defaultUrl;
  };
}

export class BackofficeNotificationAPI extends ApiBaseClass {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://api-development.mybasepay.com", baseUrl);
    }

    /**
     * Get list of notifications
     * @param isUserAdmin (optional) 
     * @param direction (optional) 
     * @return Success
     */
    getNotifications(notificationId: number, isUserAdmin: boolean | undefined, direction: DirectionEnum | undefined): Promise<BackofficeNotificationStreamModelNotificationStreamListChunkModel> {
        let url_ = this.baseUrl + "/notification/backoffice/notifications?";
        if (notificationId === undefined || notificationId === null)
            throw new globalThis.Error("The parameter 'notificationId' must be defined and cannot be null.");
        else
            url_ += "NotificationId=" + encodeURIComponent("" + notificationId) + "&";
        if (isUserAdmin === null)
            throw new globalThis.Error("The parameter 'isUserAdmin' cannot be null.");
        else if (isUserAdmin !== undefined)
            url_ += "IsUserAdmin=" + encodeURIComponent("" + isUserAdmin) + "&";
        if (direction === null)
            throw new globalThis.Error("The parameter 'direction' cannot be null.");
        else if (direction !== undefined)
            url_ += "Direction=" + encodeURIComponent("" + direction) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNotifications(_response);
        });
    }

    protected processGetNotifications(response: Response): Promise<BackofficeNotificationStreamModelNotificationStreamListChunkModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BackofficeNotificationStreamModelNotificationStreamListChunkModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BackofficeNotificationStreamModelNotificationStreamListChunkModel>(null as any);
    }

    /**
     * Get notification stream info
     * @param isUserAdmin (optional) 
     * @return Success
     */
    getNotificationsInfo(isUserAdmin: boolean | undefined): Promise<NotificationStreamInfoModel> {
        let url_ = this.baseUrl + "/notification/backoffice/notifications/info?";
        if (isUserAdmin === null)
            throw new globalThis.Error("The parameter 'isUserAdmin' cannot be null.");
        else if (isUserAdmin !== undefined)
            url_ += "isUserAdmin=" + encodeURIComponent("" + isUserAdmin) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNotificationsInfo(_response);
        });
    }

    protected processGetNotificationsInfo(response: Response): Promise<NotificationStreamInfoModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NotificationStreamInfoModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationStreamInfoModel>(null as any);
    }

    /**
     * Get one notification
     * @return Success
     */
    getNotification(notificationId: number): Promise<BackofficeNotificationStreamModel> {
        let url_ = this.baseUrl + "/notification/backoffice/notifications/{notificationId}";
        if (notificationId === undefined || notificationId === null)
            throw new globalThis.Error("The parameter 'notificationId' must be defined.");
        url_ = url_.replace("{notificationId}", encodeURIComponent("" + notificationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNotification(_response);
        });
    }

    protected processGetNotification(response: Response): Promise<BackofficeNotificationStreamModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BackofficeNotificationStreamModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BackofficeNotificationStreamModel>(null as any);
    }

    /**
     * Set status for notification
     * @return No Content
     */
    setNotificationStatus(notificationId: number, status: boolean, isUserAdmin: boolean): Promise<void> {
        let url_ = this.baseUrl + "/notification/backoffice/notifications/{notificationId}/is-new/{status}/{isUserAdmin}";
        if (notificationId === undefined || notificationId === null)
            throw new globalThis.Error("The parameter 'notificationId' must be defined.");
        url_ = url_.replace("{notificationId}", encodeURIComponent("" + notificationId));
        if (status === undefined || status === null)
            throw new globalThis.Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        if (isUserAdmin === undefined || isUserAdmin === null)
            throw new globalThis.Error("The parameter 'isUserAdmin' must be defined.");
        url_ = url_.replace("{isUserAdmin}", encodeURIComponent("" + isUserAdmin));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetNotificationStatus(_response);
        });
    }

    protected processSetNotificationStatus(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete notification by id
     * @return No Content
     */
    deleteNotificationById(notificationId: number, isUserAdmin: boolean): Promise<void> {
        let url_ = this.baseUrl + "/notification/backoffice/notifications/{notificationId}/{isUserAdmin}";
        if (notificationId === undefined || notificationId === null)
            throw new globalThis.Error("The parameter 'notificationId' must be defined.");
        url_ = url_.replace("{notificationId}", encodeURIComponent("" + notificationId));
        if (isUserAdmin === undefined || isUserAdmin === null)
            throw new globalThis.Error("The parameter 'isUserAdmin' must be defined.");
        url_ = url_.replace("{isUserAdmin}", encodeURIComponent("" + isUserAdmin));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteNotificationById(_response);
        });
    }

    protected processDeleteNotificationById(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Read all notifications before selected
     * @return No Content
     */
    readNotificationsBefore(lastNotificationId: number, isUserAdmin: boolean): Promise<void> {
        let url_ = this.baseUrl + "/notification/backoffice/notifications/read-before/{lastNotificationId}/{isUserAdmin}";
        if (lastNotificationId === undefined || lastNotificationId === null)
            throw new globalThis.Error("The parameter 'lastNotificationId' must be defined.");
        url_ = url_.replace("{lastNotificationId}", encodeURIComponent("" + lastNotificationId));
        if (isUserAdmin === undefined || isUserAdmin === null)
            throw new globalThis.Error("The parameter 'isUserAdmin' must be defined.");
        url_ = url_.replace("{isUserAdmin}", encodeURIComponent("" + isUserAdmin));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processReadNotificationsBefore(_response);
        });
    }

    protected processReadNotificationsBefore(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete all notification before selected
     * @return No Content
     */
    deleteNotificationsBefore(lastNotificationId: number, isUserAdmin: boolean): Promise<void> {
        let url_ = this.baseUrl + "/notification/backoffice/notifications/delete-before/{lastNotificationId}/{isUserAdmin}";
        if (lastNotificationId === undefined || lastNotificationId === null)
            throw new globalThis.Error("The parameter 'lastNotificationId' must be defined.");
        url_ = url_.replace("{lastNotificationId}", encodeURIComponent("" + lastNotificationId));
        if (isUserAdmin === undefined || isUserAdmin === null)
            throw new globalThis.Error("The parameter 'isUserAdmin' must be defined.");
        url_ = url_.replace("{isUserAdmin}", encodeURIComponent("" + isUserAdmin));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteNotificationsBefore(_response);
        });
    }

    protected processDeleteNotificationsBefore(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get all instant notifications
     * @return Success
     */
    getAllInstantNotifications(): Promise<BackofficeInstantNotificationsResponseModel> {
        let url_ = this.baseUrl + "/notification/backoffice/notifications/instant";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllInstantNotifications(_response);
        });
    }

    protected processGetAllInstantNotifications(response: Response): Promise<BackofficeInstantNotificationsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BackofficeInstantNotificationsResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BackofficeInstantNotificationsResponseModel>(null as any);
    }

    /**
     * Clear instant notifications
     * @param body (optional) 
     * @return No Content
     */
    clearInstantNotifications(body: number[] | undefined): Promise<void> {
        let url_ = this.baseUrl + "/notification/backoffice/notifications/instant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processClearInstantNotifications(_response);
        });
    }

    protected processClearInstantNotifications(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export enum BackofficeInstantNotificationType {
    ApprovedCustomerInstantNotify = 201,
    ApprovedAssignmentInstantNotify = 202,
}

export interface BackofficeInstantNotificationsResponseModel {
    assignmentNotifications?: InstantNotificationStreamModel[] | undefined;
    customerNotifications?: InstantNotificationStreamModel[] | undefined;
}

export interface BackofficeNotificationStreamModel {
    notificationId: number;
    type: BackofficeNotificationType;
    title: string;
    description: string;
    isNew: boolean;
    createdDate: Date;
    details: any;
    isShowPopup: boolean;
}

export interface BackofficeNotificationStreamModelNotificationStreamListChunkModel {
    maxChunkSize?: number;
    chunkSize?: number;
    hasNext?: boolean;
    info?: NotificationStreamInfoModel;
    chunk?: BackofficeNotificationStreamModel[] | undefined;
}

export enum BackofficeNotificationType {
    NewCustomerRequest = 1,
    NewAssignmentRequest = 2,
    CustomerRequestAccepted = 3,
    CustomerRequestDeclined = 4,
    AssignmentRequestAccepted = 5,
    AssignmentRequestDeclined = 6,
    PricingAgreementReceived = 7,
    NewOutreachDate = 8,
    PricingAgreementConfirmed = 9,
    PricingAgreementChangedRequest = 10,
    BroadcastMessage = 11,
    NewPartnerWithoutMPProfile = 12,
    AssignmentEndDaysNotify = 13,
    QuestionnaireNotify = 14,
    SoftStopMemberNotify = 15,
    HardStopMemberNotify = 16,
    SoftStopCustomerNotify = 17,
    HardStopCustomerNotify = 18,
    SoftStopAssignmentNotify = 19,
    HardStopAssignmentNotify = 20,
    ContractorQuestionnaireNotify = 21,
    RenewWithChangesNotify = 22,
    RenewWithoutChangesNotify = 23,
    CompletedStageMemberNotify = 24,
    CompletedStageCustomerNotify = 25,
    ApprovedCustomerNotify = 26,
    ApprovedAssignmentNotify = 27,
    CompletedStageAssignmentNotify = 28,
    NewWorkerDuplicateCreatedNotify = 29,
    AssignmentRequestedInformationProvidedNotify = 30,
    CustomerRequestedInformationProvidedNotify = 31,
    MemberRequestedInformationProvidedNotify = 32,
    KronosAssigmentIntegrationErrorNotify = 33,
    CustomerUpdatedNotify = 34,
    WorkerUpdatedNotify = 35,
    AssignmentUpdatedNotify = 36,
    AssignmentEffectiveDateNotify = 37,
    CaliforniaWorkerTerminationNotify = 38,
    ApprovedCustomerInstantNotify = 201,
    ApprovedAssignmentInstantNotify = 202,
}

export enum DirectionEnum {
    Down = 0,
    Up = 1,
}

export enum EventTypeEnum {
    NotifyStreamInfo = 100001,
    NotifyNewNotification = 100002,
    NotifySetIsNewStatus = 100003,
    NotifyDelete = 100004,
    NotifySetIsNewStatusBefore = 100005,
    NotifyDeleteBefore = 100006,
    NotifyInstantEvent = 200001,
}

export interface InstantNotificationStreamModel {
    notificationId: number;
    type: BackofficeInstantNotificationType;
    createdDate: Date;
    entityKey: string;
    workerName: string;
}

export interface NChanEventDeleteBefore {
    lastNotificationId?: number;
}

export interface NChanEventDeleteNotification {
    notificationId?: number;
}

export interface NChanEventModel {
    eventType?: EventTypeEnum;
    timestamp?: Date;
    payload?: any | undefined;
}

export interface NChanEventSetIsNewStatus {
    notificationId?: number;
    isNew?: boolean;
}

export interface NChanEventSetStatusBeforeSelected {
    lastNotificationId?: number;
    isNew?: boolean;
}

export interface NotificationStreamInfoModel {
    revision?: number;
    messageHead?: number;
    unreadCount?: number;
}

export interface NotifyDetailsAssignmentEndDaysNotifyModel {
    assignmentId?: string;
    assignmentKey?: string | undefined;
    days?: number;
}

export interface NotifyDetailsAssignmentModel {
    assignmentId?: string;
    assignmentKey?: string | undefined;
}

export interface NotifyDetailsCustomerModel {
    clientId?: string;
    customerKey?: string | undefined;
}

export interface NotifyDetailsPartnerModel {
    partnerId?: string;
}

export interface NotifyDetailsUserModel {
    userId?: string;
    memberKey?: string | undefined;
}

export interface NotifyDetailsWorkerModel {
    workerId?: string;
    workerKey?: string | undefined;
}

export interface NotifyInstantDetailsModel {
    entityKey?: string | undefined;
    workerName?: string | undefined;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}